import { render, staticRenderFns } from "./paper_export_detail.vue?vue&type=template&id=9ab26252&scoped=true&"
import script from "./paper_export_detail.vue?vue&type=script&lang=js&"
export * from "./paper_export_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab26252",
  null
  
)

export default component.exports